<template>


  <lk-cascader v-model="data" :data='goodsTypes' :disabled='disabled' :placeholder='placeholder' @on-change='handleChange'></lk-cascader>
</template>
<script>
import mapState from '../mixins/mapState';
import utils from '../libs/utils';

export default {
  name: 'goodsTypeCascader',
  mixins: [mapState],
  props: {
    value: {

    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isInStore: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      default: '请输入',
    },

  },

  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      data: [],
      goodsTypes: null,
    };
  },
  watch: {
    value() {
      this.data = this.setValue(this.value);
      // this.data = [this.value];
    },
  },
  methods: {
    handleChange(val) {
      // this.data = val;
      this.$emit('change', val[(val.length - 1)]);
      this.$emit('on-change', val[(val.length - 1)]);
    },
    handleTypes() {
      let temp = utils.deepClone(this.publicParams.goodsTypes);
      if(this.isInStore) {
        temp = temp.filter(item => item.value !== 13);
      }
      function handleArr(val) {
        val.forEach((item) => {
          item.label = item.name;
          delete item.name;
          if (item.children && item.children.length) {
            handleArr(item.children);
          }
        });
      }

      handleArr(temp);

      console.log(temp);


      return temp;
    },
    setValue(val) {
      if (!val) {
        return [];
      }
      const firstArr = [];
      let hasChildren = null;
      this.goodsTypes.forEach((item) => {
        firstArr.push(item.value);
        item.children && item.children.length && (hasChildren = item);
      });
      if (!firstArr.includes(val)) {
        return [hasChildren.value, val];
      }
      return [val];
    },
  },
  created() {
    this.goodsTypes = this.handleTypes();
  },
  mounted() {
    this.data = this.setValue(this.value);
  },
};
</script>
